import { Badge } from "../../app/components/primitives/badge";

/** Production runs the cutover only; the shadow and its reports are staging's (doc 10 §8). */
export function isProductionEnvironment(environment: string): boolean {
  return environment === "production" || environment === "prod";
}

/** "Environment: STAGING (shadow)" — which half of the cutover this instance runs. */
export function CatalogueMigrationEnvironmentBadge({
  environment,
}: {
  environment: string;
}) {
  const isProduction = isProductionEnvironment(environment);
  return (
    <Badge variant={isProduction ? "error" : "warning"}>
      Environment: {environment.toUpperCase()}
      {isProduction ? " (cutover only)" : " (shadow)"}
    </Badge>
  );
}
